import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const FlyoutTitleContext = createContext(null);
export const FlyoutContentContext = createContext(null);
export const FlyoutFooterContext = createContext(null);

export const FlyoutContext = createContext(null);
export const FlyoutProvider = ({ children }) => {
  const [openFlyoutId, setOpenFlyoutId] = useState(null);

  const openFlyout = id => {
    setOpenFlyoutId(id);
  };

  const closeFlyout = () => {
    setOpenFlyoutId(null);
  };

  return <FlyoutContext.Provider value={{ openFlyoutId, openFlyout, closeFlyout }}>{children}</FlyoutContext.Provider>;
};

FlyoutProvider.propTypes = {
  children: PropTypes.node,
};
